import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-alerta-mensagem',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alerta-mensagem.component.html',
  styleUrls: ['./alerta-mensagem.component.css']
})
export class AlertaMensagemComponent implements OnChanges, OnDestroy {
  @Input() mensagem = '';

  visivel = false;
  private temporizador?: number;

  get titulo() {
    const [primeiraLinha] = this.linhasMensagem;
    if (this.mensagemTemTitulo) {
      return primeiraLinha;
    }
    return this.ehErro ? 'Ops!!' : 'Aviso.';
  }

  get descricao() {
    if (this.mensagemTemTitulo) {
      return this.linhasMensagem.slice(1).join('\n');
    }
    return this.mensagem;
  }

  get ehErro() {
    const texto = this.mensagem.toLowerCase();
    return texto.includes('erro')
      || texto.includes('ops')
      || texto.includes('falha')
      || texto.includes('nao foi possivel')
      || texto.includes('não foi possível')
      || texto.includes('fora do horario')
      || texto.includes('fora do horário')
      || texto.includes('nao encontrado')
      || texto.includes('não encontrado');
  }

  private get linhasMensagem() {
    return this.mensagem.split('\n').map(linha => linha.trim()).filter(Boolean);
  }

  private get mensagemTemTitulo() {
    return this.linhasMensagem.length > 1;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['mensagem'] && this.mensagem) {
      this.exibir();
    }
  }

  ngOnDestroy() {
    this.cancelarTemporizador();
  }

  fechar() {
    this.visivel = false;
    this.cancelarTemporizador();
  }

  private exibir() {
    this.visivel = true;
    this.cancelarTemporizador();
    this.temporizador = window.setTimeout(() => this.fechar(), 10000);
  }

  private cancelarTemporizador() {
    if (this.temporizador) {
      window.clearTimeout(this.temporizador);
      this.temporizador = undefined;
    }
  }
}
